<div class="card" >
  <app-header titulo="Cadastro de Parâmetro de Produção" descricao="Digite as informações do parâmetro de produção"></app-header>

  <div class="formgrid grid p-fluid">
        <div class="field col-4">
          <label for="empCodemp">Empresa (Cód.): </label>
          <input
            type="text"
            id="empCodemp"
            maxlength="20"
            pInputText
            [(ngModel)]="producaoParam.empCodemp"
            [readonly]="emEdicao"
            required
          />
        </div>
        <div class="field col-4">
          <label for="varCodigo">Variedade (Cód.): </label>
          <input
            type="text"
            id="varCodigo"
            maxlength="20"
            pInputText
            [(ngModel)]="producaoParam.varCodigo"
            [readonly]="emEdicao"
            required
          />
        </div>
        <div class="field col-4">
          <label for="sufCodigo">Sufixo (Cód.): </label>
          <input
            type="text"
            id="sufCodigo"
            maxlength="20"
            pInputText
            [(ngModel)]="producaoParam.sufCodigo"
            [readonly]="emEdicao"
            required
          />
        </div>

        <div class="field col-4">
          <label for="deProcesso">Processo: </label>
          <input type="text" id="deProcesso" maxlength="100" pInputText [(ngModel)]="producaoParam.deProcesso" />
        </div>
        <div class="field col-4">
          <label for="cdProdFinalErp">Produto Final (ERP): </label>
          <input type="text" id="cdProdFinalErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdProdFinalErp" />
        </div>
        <div class="field col-4">
          <label for="deProdFinal">Descrição Produto Final: </label>
          <input type="text" id="deProdFinal" maxlength="100" pInputText [(ngModel)]="producaoParam.deProdFinal" />
        </div>

        <div class="field col-4">
          <label for="cdCcustoErp">Centro de Custo (ERP): </label>
          <input type="text" id="cdCcustoErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdCcustoErp" />
        </div>
        <div class="field col-4">
          <label for="cdCcustoInsumo">Centro de Custo Insumo: </label>
          <input type="text" id="cdCcustoInsumo" maxlength="20" pInputText [(ngModel)]="producaoParam.cdCcustoInsumo" />
        </div>
        <div class="field col-4">
          <label for="cdUnidadeErp">Unidade (ERP): </label>
          <input type="text" id="cdUnidadeErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdUnidadeErp" />
        </div>

        <div class="field col-4">
          <label for="cdProdReferErp">Produto Referência (ERP): </label>
          <input type="text" id="cdProdReferErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdProdReferErp" />
        </div>
        <div class="field col-4">
          <label for="deProdRefer">Descrição Produto Referência: </label>
          <input type="text" id="deProdRefer" maxlength="100" pInputText [(ngModel)]="producaoParam.deProdRefer" />
        </div>
        <div class="field col-4">
          <label for="fgTpProduto">Tipo de Produto: </label>
          <input type="text" id="fgTpProduto" maxlength="5" pInputText [(ngModel)]="producaoParam.fgTpProduto" />
        </div>

        <div class="field col-4">
          <label for="cdDepositoErp">Depósito (ERP): </label>
          <input type="text" id="cdDepositoErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdDepositoErp" />
        </div>
        <div class="field col-4">
          <label for="noOrdem">Número da Ordem: </label>
          <input type="text" id="noOrdem" maxlength="20" pInputText [(ngModel)]="producaoParam.noOrdem" />
        </div>
        <div class="field col-4">
          <label for="fgTpProcesso">Tipo de Processo: </label>
          <p-dropdown
            appendTo="body"
            [options]="tiposProcesso"
            optionValue="value"
            optionLabel="label"
            [(ngModel)]="producaoParam.fgTpProcesso"
            inputId="fgTpProcesso"
            placeholder="Selecione o tipo de processo"
            [showClear]="true"> <i class="pi pi-info-circle campo-info" pTooltip="Define local de integração no ERP." tooltipPosition="top"></i>
          </p-dropdown>
        </div>

        <div class="field col-4">
          <label for="cdEmpresaErp">
            Empresa (ERP):
            <i class="pi pi-info-circle campo-info" pTooltip="Se não preenchido, será utilizado o código configurado no cadastro da empresa." tooltipPosition="top"></i>
          </label>
          <input type="text" id="cdEmpresaErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdEmpresaErp" />
        </div>
        <div class="field col-4">
          <label for="cdFilialErp">
            Filial (ERP):
            <i class="pi pi-info-circle campo-info" pTooltip="Se não preenchido, será utilizado o código configurado no cadastro da empresa." tooltipPosition="top"></i>
          </label>
          <input type="text" id="cdFilialErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdFilialErp" />
        </div>
        <div class="field col-4">
          <label for="cdCentroErp">
            Centro (ERP):
            <i class="pi pi-info-circle campo-info" pTooltip="Se não preenchido, será utilizado o código configurado no cadastro da empresa." tooltipPosition="top"></i>
          </label>
          <input type="text" id="cdCentroErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdCentroErp" />
        </div>

        <div class="field col-4">
          <label for="cdMovimentoErp">Movimento (ERP): </label>
          <input type="text" id="cdMovimentoErp" maxlength="20" pInputText [(ngModel)]="producaoParam.cdMovimentoErp" />
        </div>

        <div class="field col-2 pt-4">
          <button
            pButton
            icon="pi pi-save"
            class="p-button-success"
            [label]="emEdicao ? 'Atualizar' : 'Salvar'"
            (click)="salvar()"
          ></button>
        </div>
        <div class="field col-2 pt-4">
          <button
           pButton label="Cancelar"
           icon="pi pi-times"
           class="p-button-text"
           (click)="fecharDialog()"></button>
        </div>
  </div>

  <div class="formgrid grid p-fluid mt-3" *ngIf="emEdicao">
    <div class="field col-4">
      <label>Ativo: </label>
      <div>{{ producaoParam.ativo ? 'Sim' : 'Não' }}</div>
    </div>
    <div class="field col-4">
      <label>Criado em: </label>
      <div>{{ (paraData(producaoParam.dtCriado) | date:'dd/MM/yyyy HH:mm') || '-' }}</div>
    </div>
    <div class="field col-4">
      <label>Alterado em: </label>
      <div>{{ (paraData(producaoParam.dtAlterado) | date:'dd/MM/yyyy HH:mm') || '-' }}</div>
    </div>
  </div>
</div>
